import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import { IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { RelatedEntitiesDrawerActionsStyled } from "./related-entities.styled";

interface IRelatedEntitiesDrawerActions {
  onRefresh: () => void;
  onDownload: () => void;
  isLoading: boolean;
}

export const RelatedEntitiesDrawerActions: FC<
  IRelatedEntitiesDrawerActions
> = ({ onRefresh, onDownload, isLoading }) => {
  const { t } = useTranslation();

  const handleRefresh = useEvent(() => {
    onRefresh();
  });

  const handleDownload = useEvent(() => {
    onDownload();
  });

  return (
    <RelatedEntitiesDrawerActionsStyled>
      <Tooltip title={t("general.REFRESH", { defaultValue: "Refresh" })}>
        <span>
          <IconButton
            size="small"
            onClick={handleRefresh}
            disabled={isLoading}
            aria-label={t("general.REFRESH", { defaultValue: "Refresh" })}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        title={t("general.EXPORT_EXCEL", { defaultValue: "Export Excel" })}
      >
        <span>
          <IconButton
            size="small"
            onClick={handleDownload}
            disabled={isLoading}
            aria-label={t("general.EXPORT_EXCEL", {
              defaultValue: "Export Excel",
            })}
          >
            <DownloadIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </RelatedEntitiesDrawerActionsStyled>
  );
};
